import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../AnimationContents';
import { GameLogic } from '../Logic/GameLogic';
import { BorderModel } from '../Models/BorderModel';

export interface IBorderControllerOptions {
}

export class BorderController extends AnimationBaseController {
    $model: BorderModel;

    public constructor(
        @Inject private _options: IBorderControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('BorderController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        console.log('outline_' + this.$model.type);

        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'outline_' + this.$model.type,
            childControllers: {},
            modelWatch: {
                pos: (pos: [number, number]) => {
                    this.x = pos[0];
                    this.y = pos[1];
                },
                rotation : (value: number) => {
                    this.rotation = value;
                },
                width : (value: number) => {
                    this.display.width = value;
                },
                height : (value: number) => {
                    this.display.height = value;
                },
                visible: (value: boolean) => {
                    this.visible = value;
                },
            },
        };
    }

    protected onInitialize(): void {
        this.rotation = this.$model.rotation;
        this.display.width = this.$model.width;
        this.display.height = this.$model.height;
    }
}
